import { datadogRum } from '@datadog/browser-rum';

const runDatadog = () => {
  datadogRum.init({
    applicationId: 'd612046a-4b75-418e-8b4b-5253c9c2cbb7',
    clientToken: 'puba6255f970431a2a2078347309c855f56',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'ims-scanner',
    env: 'prod',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    allowedTracingUrls: [
      'https://api.alpinehomeair.com',
      'https://partnernet.alpinehomeair.com',
      'https://imsapi.alpinehomeair.com'
    ],
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackSessionAcrossSubdomains: true,
    defaultPrivacyLevel: 'allow',
    beforeSend: (event) => {
      if (event.type === 'resource' && event.resource.type === 'csp') {
        // Drop CSP violation events
        return false;
      }
      return true;
    }
  });
};
export default runDatadog;
